<div fxLayout="column" fxLayoutGap="16px">
  <strong>{{'action.title' | translate}}</strong>
  <mat-radio-group [(ngModel)]="actionId" (ngModelChange)="updateForwardingTypeDefault()" fxLayout="column"
                   fxLayoutGap="16px">
    <mat-radio-button *ngFor="let type of absenceActions" class="settingsButton" [value]="type.key">

      <span *ngIf="actionId !== type.key || type.key < 2 || type.key > 5">{{type.text | translate}}</span>

      <div *ngIf="actionId === 2 && type.key === 2" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
        <span>{{'action.my_service' | translate}}</span>
        <button mat-button color="primary" (click)="configureService()">{{'action.configure_my_service' | translate}}
        </button>
      </div>
      <div *ngIf="actionId === 3 && type.key === 3">
        <mat-form-field class="numberSelection">
          <mat-select [(ngModel)]="colleagueNumber" (selectionChange)="changeNumber($event)"
                      *ngIf="actionId === 3 && type.key === 3" placeholder="{{type.text | translate}}">
            <mat-option *ngFor="let contact of colleagueNumbers" [value]="contact.phoneNumber">{{contact.name}}
              {{contact.getFormattedNumber()}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="actionId === 4 && type.key === 4">
        <mat-form-field class="numberSelection">
          <mat-select [(ngModel)]="mainNumber" (selectionChange)="changeNumber($event)" placeholder="{{type.text | translate}}">
            <mat-option *ngFor="let number of mainNumbers" [value]="number.phoneNumber">{{number.name}} {{number.getFormattedNumber()}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <form (ngSubmit)="changeNumber()" *ngIf="actionId === 5 && type.key === 5">
        <mat-form-field>
          <input matInput [(ngModel)]="otherNumber" [ngModelOptions]="{standalone: true}"
                 placeholder="{{type.text | translate}}">
          <button mat-icon-button matSuffix matTooltip="{{'action.save_number' | translate }}">
            <mat-icon>save</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </mat-radio-button>
  </mat-radio-group>
  <button mat-raised-button (click)="onBack()" color="primary">
    {{'global.back' | translate}}
  </button>
</div>
